import React, { useEffect, useState } from 'react';
import Button from '../atom/Button';
import Modal from '../modecules/Modal';
import Exclamation from '../../assets/images/exclamation.png';
import UserBoardService from '../../service/UserBoardService';
import styled from 'styled-components';
import ModalLookup from '../modecules/ModalLookup';
import TitleHeader from '../modecules/TitleHeader';
import TextInput from '../atom/TextInput';
import TextArea from '../atom/TextArea';
import FielUpload from '../atom/FileUpload';

// import ReCAPTCHA from "react-google-recaptcha";
// import Captcha from "../atom/Capcha";

function UserVocWritePage() {
  const [modalOpen, setModalOpen] = useState(false);
  const [lookUp, setLookup] = useState(false);
  const [uploadFile, setUploadFile] = useState<File | null>(null);
  // 단일 form 상태로 통합하여 코드 가독성 및 확장성 향상
  const [form, setForm] = useState({
    writer: '',
    phoneNum: '',
    companyName: '',
    title: '',
    text: '',
    pwd: '',
    email: ''
  } as {
    writer: string;
    phoneNum: string;
    companyName: string;
    title: string;
    text: string;
    pwd: string;
    email: string;
  });
  const [vocNum, setVocNum] = useState<number | undefined>(undefined);
  const [formData, setFormData] = useState<unknown>(null);
  const [checkCapcha, setCheckCapcha] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // const date1 = new Date("2023-02-13 15:41:00");
  // console.log(Date.now() - date1.getTime());

  const lookUpModal = () => {
    setModalOpen(true);
  };
  //사이트 진입시 출처 확인
  const originUrlKeyValues = window.location.search;
  const urlParams = new URLSearchParams(originUrlKeyValues);
  const originStie = urlParams.get('origin');
  const originStieCode = urlParams.get('code');
  // console.log(originStieCode);

  //출처가 없을 시
  useEffect(() => {
    if (!originStie || !originStieCode) {
      //기타 코드
      //   setServiceName("기타");
      //   setServiceSortation("06");
      sessionStorage.setItem('origin', '기타');
      sessionStorage.setItem('code', '06');
    }
  }, [originStie, originStieCode]);

  //출처가 있을 시 바뀔 때
  useEffect(() => {
    if (!!originStie && originStie !== null && !!originStieCode && originStieCode !== null) {
      sessionStorage.setItem('origin', `${originStie}`);
      sessionStorage.setItem('code', `${originStieCode}`);
    }
  }, [originStie, originStieCode]);

  //서버로 문의글 전송
  const sendDataToServer = async () => {
    if (isSubmitting) return; // 중복 제출 방지

    if (!form.writer || !form.phoneNum || !form.pwd || !form.title || !form.text || !form.email) {
      alert('작성되지 않은 항목이 있습니다 내용을 다시 한번 확인해주세요');
      return;
    }

    setIsSubmitting(true);
    lookUpModal();

    const writePayload = {
      title: form.title || '',
      content: form.text || '',
      name: form.writer,
      fileName: uploadFile?.name || '',
      password: form.pwd || '',
      phoneNumber: form.phoneNum || '',
      companyName: form.companyName || '',
      serviceSortation: originStieCode || '',
      email: form.email || ''
    };

    const filesToSend: Record<string, Blob> = {
      data: uploadFile || new Blob()
    };

    try {
      const response = await UserBoardService.writeVoc(writePayload, filesToSend);
      if (response.status === 'success') {
        const resp = response as { data: { no?: number } };
        setVocNum(resp.data.no);
        setFormData(resp.data);
      } else {
        alert('문의글 작성이 실패하였습니다. 관리자에게 문의해주세요');
      }
    } catch (err) {
      alert('서버와 통신 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const openLookup = () => {
    setLookup(true);
  };
  const closeLookup = () => {
    setLookup(false);
  };

  // 폼 변경 핸들러 (공통)
  const handleChange =
    (field: keyof typeof form) =>
    (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const value = (e.target as HTMLInputElement).value;
      setForm(prev => ({ ...prev, [field]: value }));
    };

  // 전화번호 입력 전용 (maxlength 처리)
  const handlePhoneInput = (e: React.FormEvent<HTMLInputElement>) => {
    const target = e.currentTarget as HTMLInputElement;
    if (target.value.length > target.maxLength)
      target.value = target.value.slice(0, target.maxLength);
    setForm(prev => ({ ...prev, phoneNum: target.value }));
  };

  // 파일 업로드 항목 설정 (타입 명시)
  const fileInputs: Array<{
    setter: React.Dispatch<React.SetStateAction<File | null>>;
    file: File | null;
    label: string;
    id: string;
    accept: string;
  }> = [
    {
      setter: setUploadFile,
      file: uploadFile,
      label: '첨부파일(선택)',
      id: 'general-file',
      accept: '.zip,.rar,.7zip,.pdf,.jpg,.jpeg,.png'
    }
  ];

  return (
    <>
      {
        <PageBox>
          <TitleHeader title={'VOC 접수'} subTitle={'문의하실 내용을 작성해주세요.'} />

          <Box1>
            <TextInput
              boxWidth={22}
              labelWidth={28}
              inputWidth={70}
              onChange={handleChange('writer')}
              htmlFor="VocWriteName"
              labelName="작성자"
              name="inputName"
              type="text"
              placeholder="이름"
              required
              maxLength={10}
            />
            <TextInput
              boxWidth={22}
              labelWidth={28}
              inputWidth={70}
              onChange={handleChange('phoneNum')}
              htmlFor="VocWritePhone"
              labelName="연락처"
              onInput={handlePhoneInput}
              name="inputName"
              type="number"
              placeholder="'-'을 제외한 숫자"
              maxLength={11}
              appearance={'none'}
            />
            <TextInput
              boxWidth={22}
              labelWidth={28}
              inputWidth={70}
              onChange={handleChange('companyName')}
              htmlFor="CompanyName"
              labelName="회사명"
              name="companyName"
              type="text"
              placeholder="회사명을 입력해주세요"
              maxLength={50}
            />
            <TextInput
              boxWidth={22}
              labelWidth={28}
              inputWidth={70}
              onChange={handleChange('pwd')}
              labelName="패스워드"
              name="inputName"
              type="password"
              placeholder="6자리 미만"
              maxLength={6}
            />
          </Box1>
          <Box2>
            <TextInput
              boxWidth={100}
              labelWidth={9}
              inputWidth={91}
              onChange={handleChange('title')}
              htmlFor="VocTitle"
              labelName="제목"
              name="VocTitle"
              type="text"
              placeholder="제목을 입력해주세요"
              required
              maxLength={30}
            />
            <TextArea
              boxWidth={100}
              labelWidth={9}
              inputWidth={91}
              inputHeight={300}
              htmlFor="VocInfo"
              labelName="내용"
              onChange={handleChange('text')}
              name="VocInfo"
              placeholder="문의내용을 800자 이내로 상세하게 작성해주세요"
              isRequired={true}
              maxLength={1000}
            />
            <TextInput
              boxWidth={100}
              labelWidth={9}
              inputWidth={91}
              onChange={handleChange('email')}
              labelName="이메일"
              name="inputName"
              type="email"
              placeholder="답변받으실 이메일을 입력해주세요"
            />
          </Box2>
          <Box3>
            <div style={{ width: '70%' }}>
              {fileInputs.map(f => (
                <FielUpload
                  key={f.id}
                  labelWidth={30}
                  inputWidth={70}
                  setUploadFile={f.setter}
                  uploadFile={f.file}
                  label={f.label}
                  id={f.id}
                  accept={f.accept}
                />
              ))}
            </div>
            <ServiceOriginWrapper>
              <label>서비스 구분</label>
              <div>{!!originStie && originStie !== null ? <p>{originStie}</p> : <p>미분류</p>}</div>
            </ServiceOriginWrapper>
          </Box3>
          <Line></Line>
          <Box4>
            <Button
              text={'VOC 조회'}
              backgroundColor={'#388fc0'}
              fontColor={'white'}
              borderRadius={'5px'}
              width={'127px'}
              onClick={openLookup}
              type={'submit'}
            />
            <Button
              type={'submit'}
              text={'등록'}
              backgroundColor={'#388fc0'}
              fontColor={'white'}
              borderRadius={'5px'}
              onClick={() => {
                sendDataToServer();
              }}
              disabled={isSubmitting}
            />
          </Box4>
          <ModalBox>
            <ModalLookup text={'VOC 조회'} open={lookUp} close={closeLookup} />
          </ModalBox>
          <ModalBox2>
            <Modal
              open={modalOpen}
              formData={formData}
              checkCapcha={checkCapcha}
              setCheckCapcha={setCheckCapcha}
            >
              <div className="modalStyle">
                <img src={Exclamation} alt="Exclamation Icon" />
                <p>등록되었습니다.</p>
              </div>
              <div className="listNum">
                <p>게시글 번호 : {vocNum}</p>
                <p>*게시글 번호는 VOC 내역 조회 시 사용됩니다.</p>
              </div>
            </Modal>
          </ModalBox2>
        </PageBox>
      }
    </>
  );
}

//css
const PageBox = styled.div`
  display: flex;
  width: 60%;
  /* left: 20%; */
  /* position: fixed; */
  flex-direction: column;
  align-items: center;
  @media ${props => props.theme.device.laptop} {
    margin-top: 40px;
    width: 80%;
  }
`;

const Box1 = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 60px;
  @media ${props => props.theme.device.laptop} {
    margin-top: 30px;
    flex-direction: column;
  }
`;
const Box2 = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 12px;
`;
const Box3 = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  @media ${props => props.theme.device.laptop} {
    flex-direction: column;
  }
`;

const ServiceOriginWrapper = styled.div`
  display: flex;
  width: 18%;
  justify-content: right;
  align-items: center;
  font-size: 12px;
  > div > p {
    margin-left: 8px;
  }
  @media ${props => props.theme.device.laptop} {
    margin-top: 20px;
    width: 100%;
  }
`;
const Line = styled.div`
  width: 100%;
  margin-top: 32px;
  border-top: solid 1px #ccc;
`;
const Box4 = styled.div`
  width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const ModalBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;
const ModalBox2 = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export default UserVocWritePage;
